module.exports = __webpack_public_path__ + "img/johkers-logotyp-rakt-upp-och-ned.e615fdb9.jpg";